/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import {
    OperatorsActions,
    OperatorsActionType,
    fetchOperatorsListErrorAction,
    fetchOperatorsListSuccessAction,
    downloadOperatorsListAsExcelSuccessAction,
    downloadOperatorsListAsExcelErrorAction,
} from '../actions/operatorsActions';
import { operatorsClient } from '../api/operators/operatorsClient';
import { OperatorsListRequestParams } from '../api/operators/operatorsClient.typings';
import { OperatorsState } from '../reducers/operatorsReducer';
import { switchMap, map, catchError, takeUntil } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';

export const getOperatorsListEpic: Epic<OperatorsActions> = (action$, state) => {
    return action$.pipe(
        ofType(OperatorsActionType.FETCH_NEXT_PAGE_START, OperatorsActionType.APPLY_FILTER),
        switchMap(() => {
            const queryParams = makeOperatorsListRequestParamsFromState(state.value.operatorsReducer);
            return from(operatorsClient.listOperators(queryParams)).pipe(
                map((resp) => fetchOperatorsListSuccessAction(resp)),

                catchError((err: AxiosError) =>
                    of(
                        fetchOperatorsListErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.operatorsListNotFound')),
                        ),
                    ),
                ),

                takeUntil(action$.pipe(ofType(OperatorsActionType.EXIT_REGISTRY_OPERATORS_LIST_PAGE))),
            );
        }),
    );
};

function makeOperatorsListRequestParamsFromState(state: OperatorsState): OperatorsListRequestParams {
    return {
        ...state.filterParams,
        limit: state.limit,
        afterKey: state.afterKey,
    };
}

export const operatorsListDownloadEpic: Epic<OperatorsActions> = (actions$, state$) => {
    return actions$.pipe(
        ofType(OperatorsActionType.DOWNLOAD_EXCEL),
        switchMap(() => {
            return from(
                operatorsClient.downloadOperatorsListAsExcel({ ...state$.value.operatorsReducer.filterParams }),
            ).pipe(
                map(() => downloadOperatorsListAsExcelSuccessAction()),
                catchError((err: AxiosError) =>
                    of(
                        downloadOperatorsListAsExcelErrorAction(
                            parseError(err, i18n.t('downloadings.errors.requestToCreateFileFailed')),
                        ),
                    ),
                ),
                takeUntil(actions$.pipe(ofType(OperatorsActionType.EXIT_REGISTRY_OPERATORS_LIST_PAGE))),
            );
        }),
    );
};
